import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/blueChange.png';
import _imports_1 from '../../assets/img/dataScreen/branch.png';
import _imports_2 from '../../assets/img/dataScreen/num.png';
import _imports_3 from '../../assets/img/dataScreen/notNum.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-67838eed"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "contain"
};
var _hoisted_2 = {
  class: "bigdata"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "name"
  }, " 党建大数据 ", -1);
});

var _hoisted_4 = {
  class: "count"
};
var _hoisted_5 = {
  class: "li"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1
  }, null, -1);
});

var _hoisted_7 = {
  class: "statistics"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top"
  }, " 支部数量（总数） ", -1);
});

var _hoisted_9 = {
  class: "bom"
};
var _hoisted_10 = {
  class: "li"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2
  }, null, -1);
});

var _hoisted_12 = {
  class: "statistics"
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top"
  }, " 党员人数（总数） ", -1);
});

var _hoisted_14 = {
  class: "bom"
};
var _hoisted_15 = {
  class: "li"
};

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3
  }, null, -1);
});

var _hoisted_17 = {
  class: "statistics"
};

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top"
  }, " 非党员人数（总数） ", -1);
});

var _hoisted_19 = {
  class: "bom"
};
var _hoisted_20 = {
  class: "screen-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Thought = _resolveComponent("Thought");

  var _component_Mission = _resolveComponent("Mission");

  var _component_PartyStatistics = _resolveComponent("PartyStatistics");

  var _component_Activity = _resolveComponent("Activity");

  var _component_PartyPayment = _resolveComponent("PartyPayment");

  var _component_ExamOnline = _resolveComponent("ExamOnline");

  var _component_TrainOnline = _resolveComponent("TrainOnline");

  var _component_Meeting = _resolveComponent("Meeting");

  var _component_Democracy = _resolveComponent("Democracy");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("img", {
    class: "changeStyle",
    src: _imports_0,
    alt: "",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.changeStyle && _ctx.changeStyle.apply(_ctx, arguments);
    })
  })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.dataCount.orgCount), 1)])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.dataCount.partyCount), 1)])]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.dataCount.unPartyCount), 1)])])])]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_Thought, {
    ref: "Thoughts",
    class: "screen-content-normalitem licla heightOne"
  }, null, 512), _createVNode(_component_Mission, {
    ref: "Missions",
    class: "screen-content-bigitem bigitemspa licla heightOne"
  }, null, 512), _createVNode(_component_PartyStatistics, {
    ref: "PartyStatisticss",
    class: "screen-content-normalitem licla heightOne"
  }, null, 512), _createVNode(_component_Activity, {
    class: "screen-content-normalitem licla heightTwo"
  }), _createVNode(_component_PartyPayment, {
    ref: "PartyPayments",
    class: "screen-content-bigitem licla heightTwo"
  }, null, 512), _createVNode(_component_ExamOnline, {
    ref: "examOnlineMain",
    class: "screen-content-normalitem licla heightTwo"
  }, null, 512), _createVNode(_component_TrainOnline, {
    class: "screen-content-normalitem licla heightThree"
  }), _createVNode(_component_Meeting, {
    class: "screen-content-bigitem bigitemspa licla heightThree"
  }), _createVNode(_component_Democracy, {
    class: "screen-content-normalitem licla heightThree"
  })])]);
}